import React, { useEffect, useState } from "react";
// Modal
import CashAccount from "./Component/CashAccount";
// components
import FinancialTable from "../../../components/Table/FinancialTable";
import Icon from "../../../components/Icon";
// image
import defaultBankImage from "../../../assets/images/bank-card-images/default-bank-img.png"
// apis
import { getBankAccountList, modifyCashAccountsInfo } from "../../../apis/finances/bank";
import { forEach, isEmpty } from "lodash";
import CashAccountPreBalance from "./Component/CashAccountPreBalance";

// normal, error, notUsed,
const CardAccountMapping = ({ permission }) => {
  const [fields] = useState([
    {
      key: "name",
      className: "finance-name",
      onValue: (value, field, data) => {
        const { name } = data
        return (
          <>
            <div style={ data.isUsing ? {} : {opacity: 0.5}}>
              <Icon className="bank-img-wrap" src={defaultBankImage} alt={name} />
              <span className="margin-left-8">
                {name}
              </span>
            </div>
          </>
        );
      },
    },
    {
      key: "memo",
      className: "finance-description",
      onValue: (value, field, data) => {
        const { memo } = data
        return (
          <>
            <div style={ data.isUsing ? {} : {opacity: 0.5}}>
                {memo}
            </div>
          </>
        );
      },
    },
  ]);
  const [status, setStatus] = useState({
    use: 0,
  });
  const [list, setList] = useState([]);
  // 계좌 추가, 수정
  const [open, setOpen] = useState(false)
  const [mode, setMode] = useState('create')
  const [cashAccountData, setCashAccountData] = useState({})
  // 기초 잔액
  const [balanceOpen, setBalanceOpen] = useState(false)
  const [bankData, setBankData] = useState({})

  const headerbutton = [
    {
      label: "새 기타거래",
      color: "line",
      size: "sm",
      action: () => {
        setOpen(true)
        setMode('create')
      },
      className: "float-right",
    },
  ];

  useEffect(() => {
    if (!isEmpty(list)) {
      let use = 0;
      forEach(list, account => {
        if (account.isUsing === 1) use++
      })

      setStatus({
        use,
      })
    }
  }, [list])

  useEffect(() => {
    submit();
  }, []);

  const submit = () => {
    getBankAccountList(false, 'cash_account').then((res) => {
      setList(res.data.bankAccounts.map((bank) => ({
        ...bank,
        isUsing: bank.status === 'enabled' ? 1 : 0
      })))
    })
  };

  const setUsingAction = (checked, idx) => {
    const body = {
      status: checked ? 'enabled' : 'disabled'
    }
    modifyCashAccountsInfo(idx, body).then(() => {
      submit()
    }).catch(() => { }).finally(() => { })
  }

  const controller = {
    rowButtons: [
      // {
      //   isHide: !(permission.level > 1),
      //   label: "삭제",
      //   type: "delete",
      //   className: "margin-right-8",
      //   action: (data) => {
      //     alert('api 개발 중입니다.')
      //   },
      // },
      {
        isHide: !(permission.level > 1),
        label: "수정",
        type: "edit",
        action: (data) => {
          setOpen(true)
          setMode('modify')
          setCashAccountData(data)
        },
      },
    ],
    setUsingAction,
    switchDisabled: !(permission.level > 1),
    controlButton: {
      label: (data) => {
        return <div style={ data.isUsing ? {} : {opacity: 0.5}}><span className="pre-balance">기초잔액 반영</span></div>
      },
      action: (data) => {
        setBankData(data)
        setBalanceOpen(true)
      },
    }
  }

  return (
    <>
      <FinancialTable
        title="기타거래"
        fields={fields}
        list={list}
        status={status}
        buttons={permission.level > 1 ? headerbutton : []}
        controller={controller}
      />
      <CashAccount
        open={open}
        setOpen={setOpen}
        mode={mode}
        submit={submit}
        data={cashAccountData}
      />
      <CashAccountPreBalance
        permission={permission}
        open={balanceOpen}
        setOpen={setBalanceOpen}
        data={bankData}
        submit={submit}
      />
    </>
  );
};

export default CardAccountMapping;
